/* gara-hero-cycle.js
 * Cycles the homepage hero through Benjamin's Unsplash collections based on
 * the active discipline filter:
 *   discipline-mx   -> "Hero cycle"      (ELL-WyufX04)
 *   discipline-moto -> "Hero cycle moto" (akHILgNIg3E)
 *   discipline-all  -> mx + moto pools merged
 *
 * The displayed photo is keyed to a 2-hour UTC bucket per pool, so every
 * visitor in the same window sees the same image. Order is shuffled with a
 * prime stride (7919) so rotation feels random rather than sequential.
 *
 * Regenerate the photo arrays by running:
 *   python gara_refresh_hero_cycle.py
 */
(function(){
  var POOLS = {
  "mx": [
    {
      "id": "nQ2TaA_zphE",
      "url": "https://images.unsplash.com/photo-1580357703484-4bbb329b83a7?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MXxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "people riding motorcycle on brown grass field during daytime",
      "user_name": "vikram sundaramoorthy",
      "user_link": "https://unsplash.com/@vikramstudio46?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/nQ2TaA_zphE/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MXxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "vcB5ExVOTJQ",
      "url": "https://images.unsplash.com/photo-1551239741-60537adebdb2?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MnxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "people at freestyle motocross",
      "user_name": "vikram sundaramoorthy",
      "user_link": "https://unsplash.com/@vikramstudio46?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/vcB5ExVOTJQ/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MnxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "AcQbPfXoSD0",
      "url": "https://images.unsplash.com/photo-1589360570951-3cb06a01690a?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258M3xFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "man in blue and yellow jacket riding motocross dirt bike",
      "user_name": "michael weir",
      "user_link": "https://unsplash.com/@bushmush?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/AcQbPfXoSD0/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258M3xFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "jyxThcK5c_s",
      "url": "https://images.unsplash.com/photo-1683704206159-692b9f3e28f4?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258NHxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "a man riding a dirt bike on top of a dirt field",
      "user_name": "Tomas",
      "user_link": "https://unsplash.com/@tomas_chudy?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/jyxThcK5c_s/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258NHxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "YQQWQmTddek",
      "url": "https://images.unsplash.com/photo-1592247034198-9dd62e0b7a9e?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258NXxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "red black and white nike air max 90 shoe",
      "user_name": "Egor Myznik",
      "user_link": "https://unsplash.com/@vonshnauzer?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/YQQWQmTddek/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258NXxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "S1M7nyDUriI",
      "url": "https://images.unsplash.com/photo-1508987387448-da90f527534c?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258NnxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "person riding on motocross dirt bike",
      "user_name": "Glenn Hansen",
      "user_link": "https://unsplash.com/@hansenhouse?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/S1M7nyDUriI/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258NnxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "SRwxbD0VuUg",
      "url": "https://images.unsplash.com/photo-1629223476921-49a9ba5c26e4?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258N3xFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "red and black motocross dirt bike",
      "user_name": "Paulo Freitas",
      "user_link": "https://unsplash.com/@paulofreitasph?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/SRwxbD0VuUg/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258N3xFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "mCOEahKOhQs",
      "url": "https://images.unsplash.com/photo-1727081525676-dc20100f744d?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258OHxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "A group of people riding dirt bikes on a dirt track",
      "user_name": "Max Leveridge",
      "user_link": "https://unsplash.com/@maxleveridge?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/mCOEahKOhQs/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258OHxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "-KjPNAmE02U",
      "url": "https://images.unsplash.com/photo-1602478411948-e28ad9b247b8?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258OXxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "man in green and white motocross helmet riding motocross dirt bike",
      "user_name": "Alexander Aguero",
      "user_link": "https://unsplash.com/@alexcrphoto?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/-KjPNAmE02U/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258OXxFTEwtV3l1ZlgwNHx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "ecV40eg4bLQ",
      "url": "https://images.unsplash.com/photo-1591037307610-9b7bcdffb72a?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MTB8RUxMLVd5dWZYMDR8fHx8fDJ8fDE3Nzg3NTM0NDV8&ixlib=rb-4.1.0",
      "alt": "man in red and white motocross helmet riding motocross dirt bike",
      "user_name": "Freddie",
      "user_link": "https://unsplash.com/@fredinand?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/ecV40eg4bLQ/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MTB8RUxMLVd5dWZYMDR8fHx8fDJ8fDE3Nzg3NTM0NDV8"
    },
    {
      "id": "DRZSodn4PO4",
      "url": "https://images.unsplash.com/photo-1575396565846-19fe83e261bf?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MTF8RUxMLVd5dWZYMDR8fHx8fDJ8fDE3Nzg3NTM0NDV8&ixlib=rb-4.1.0",
      "alt": "man riding motocross bike",
      "user_name": "viklundvisuals",
      "user_link": "https://unsplash.com/@viklundvisuals?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/DRZSodn4PO4/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MTF8RUxMLVd5dWZYMDR8fHx8fDJ8fDE3Nzg3NTM0NDV8"
    },
    {
      "id": "g9dGtzw2cfU",
      "url": "https://images.unsplash.com/photo-1605121476668-ae388fa8fe27?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MTJ8RUxMLVd5dWZYMDR8fHx8fDJ8fDE3Nzg3NTM0NDV8&ixlib=rb-4.1.0",
      "alt": "man in black helmet riding orange and black atv",
      "user_name": "Tucker Scott",
      "user_link": "https://unsplash.com/@_tucker_scott?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/g9dGtzw2cfU/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MTJ8RUxMLVd5dWZYMDR8fHx8fDJ8fDE3Nzg3NTM0NDV8"
    },
    {
      "id": "NhZtol0U0dE",
      "url": "https://images.unsplash.com/photo-1542550546-88afdd84b64f?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MTN8RUxMLVd5dWZYMDR8fHx8fDJ8fDE3Nzg3NTM0NDV8&ixlib=rb-4.1.0",
      "alt": "man riding red motocross dirt bike",
      "user_name": "Andraz Lazic",
      "user_link": "https://unsplash.com/@andrazlazic?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/NhZtol0U0dE/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MTN8RUxMLVd5dWZYMDR8fHx8fDJ8fDE3Nzg3NTM0NDV8"
    }
  ],
  "moto": [
    {
      "id": "HuQYAA6_VKI",
      "url": "https://images.unsplash.com/photo-1711327697470-fe6178200c84?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MXxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "a person riding a motorcycle on a race track",
      "user_name": "25snn",
      "user_link": "https://unsplash.com/@25snn?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/HuQYAA6_VKI/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MXxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "cUpu9FLs6ok",
      "url": "https://images.unsplash.com/photo-1718718652551-bba6caa8bc36?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258Mnxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "A man taking a picture of a motorcycle",
      "user_name": "Seba Bura",
      "user_link": "https://unsplash.com/@sebabura?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/cUpu9FLs6ok/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258Mnxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "2g5cqBqUQME",
      "url": "https://images.unsplash.com/photo-1566239814045-c9d457a8e47b?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258M3xha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "person riding and bending sports bike on track field during daytime",
      "user_name": "Oskar Kadaksoo",
      "user_link": "https://unsplash.com/@oskark?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/2g5cqBqUQME/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258M3xha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "_LEjyN3hJIA",
      "url": "https://images.unsplash.com/photo-1638820371370-da1816ec56af?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258NHxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "a person riding a motorcycle on a race track",
      "user_name": "shaun Bexley",
      "user_link": "https://unsplash.com/@sbexley?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/_LEjyN3hJIA/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258NHxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "EDeqquZUAVc",
      "url": "https://images.unsplash.com/photo-1625812181697-0428b08ad632?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258NXxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "white and black sports bike on road during daytime",
      "user_name": "karthegan Padmanaban",
      "user_link": "https://unsplash.com/@gixxerkidd?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/EDeqquZUAVc/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258NXxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "3tnrbRL2Ij4",
      "url": "https://images.unsplash.com/photo-1720958357699-df1a05ebe009?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258Nnxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "A person riding a motorcycle on a race track",
      "user_name": "Sara Ruffoni",
      "user_link": "https://unsplash.com/@ssarasframes?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/3tnrbRL2Ij4/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258Nnxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "AkEMVbdEmUQ",
      "url": "https://images.unsplash.com/photo-1489731110502-23f1239ea56c?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258N3xha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "two people riding sports bikes on gray asphalt road during daytime",
      "user_name": "Joe Neric",
      "user_link": "https://unsplash.com/@jneric?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/AkEMVbdEmUQ/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258N3xha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "2dk0_XbUevo",
      "url": "https://images.unsplash.com/photo-1516728513226-23c4045123a0?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258OHxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "man riding sports bike on gray road",
      "user_name": "Garry Neesam",
      "user_link": "https://unsplash.com/@cathus?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/2dk0_XbUevo/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258OHxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "HHunRG19kF8",
      "url": "https://images.unsplash.com/photo-1489731007795-388eee095ff6?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258OXxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw&ixlib=rb-4.1.0",
      "alt": "group of people riding sports motorcycles",
      "user_name": "Joe Neric",
      "user_link": "https://unsplash.com/@jneric?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/HHunRG19kF8/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258OXxha0hJTGdOSWczRXx8fHx8Mnx8MTc3ODc1MzQ0NXw"
    },
    {
      "id": "fjVnFfC1-BY",
      "url": "https://images.unsplash.com/photo-1514760263916-4ac83991b2e6?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MTB8YWtISUxnTklnM0V8fHx8fDJ8fDE3Nzg3NTM0NDV8&ixlib=rb-4.1.0",
      "alt": "motorcycle racer on track",
      "user_name": "Harlie Raethel",
      "user_link": "https://unsplash.com/@harlsta?utm_source=garamoto&utm_medium=referral",
      "download_location": "https://api.unsplash.com/photos/fjVnFfC1-BY/download?ixid=M3w5MjczOTd8MHwxfGNvbGxlY3Rpb258MTB8YWtISUxnTklnM0V8fHx8fDJ8fDE3Nzg3NTM0NDV8"
    }
  ]
};

  /* "all" pool is the merged set of mx + moto. */
  POOLS.all = POOLS.moto.concat(POOLS.mx);

  var BUCKET_MS = 2 * 60 * 60 * 1000;
  var CLIENT_ID = 'yTkCuVyP-_XQ3jrbfXa8-pl0DkkGa4xyOoPAvffjDBw';
  var lastBucket = -1;
  var lastKey = '';

  function currentDiscipline(){
    var b = document.body.classList;
    if (b.contains('discipline-mx'))   return 'mx';
    if (b.contains('discipline-moto')) return 'moto';
    if (b.contains('discipline-all'))  return 'all';
    /* The discipline filter (and the body class it set) was removed, so there's
       usually no class now. Default to the full merged pool — the fresh-visitor
       default was always 'all' anyway — so the hero keeps cycling every photo. */
    return 'all';
  }

  function pickIndex(pool){
    var bucket = Math.floor(Date.now() / BUCKET_MS);
    return (bucket * 7919) % pool.length;
  }

  function findHero(){
    return document.querySelector('.gara-home-hero')
        || document.querySelector('.video-parent-section.hero');
  }

  function ensureOverlay(hero){
    var bg = hero.querySelector('.gara-hero-cycle-bg');
    if (!bg){
      bg = document.createElement('div');
      bg.className = 'gara-hero-cycle-bg';
      bg.setAttribute('aria-hidden', 'true');
      hero.insertBefore(bg, hero.firstChild);
    }
    return {bg: bg};
  }

  function paint(photo, els){
    /* 2026-09-18 speed pass: was a fixed w=2400 (491 KB on every home load).
       Ask Unsplash for the width this screen actually paints (cover), capped
       at 2400; a phone gets ~600-900 px, a laptop ~1500-1900. */
    var _dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var _w = Math.min(2400, Math.max(600, Math.round((window.innerWidth || 1600) * _dpr)));
    var url = photo.url + '&w=' + _w + '&q=78&fit=crop&crop=entropy&auto=format';
    var img = new Image();
    img.onload = function(){
      els.bg.style.backgroundImage = 'url("' + url + '")';
      els.bg.classList.add('is-loaded');
    };
    img.src = url;

    /* Quietly ping Unsplash's download tracker (required by their API terms). */
    if (photo.download_location){
      try {
        fetch(photo.download_location + '?client_id=' + CLIENT_ID, {mode: 'no-cors'}).catch(function(){});
      } catch(_){}
    }
  }

  function activate(force){
    var disc = currentDiscipline();
    if (!disc) return;
    var pool = POOLS[disc];
    if (!pool || !pool.length) return;
    var hero = findHero();
    if (!hero) return;
    var idx = pickIndex(pool);
    var key = disc + ':' + idx;
    if (!force && key === lastKey) return;
    lastKey = key;
    lastBucket = Math.floor(Date.now() / BUCKET_MS);
    var els = ensureOverlay(hero);
    paint(pool[idx], els);
  }

  function deactivate(){
    var bg = document.querySelector('.gara-hero-cycle-bg');
    if (bg) bg.classList.remove('is-loaded');
    lastKey = '';
  }

  function sync(){
    if (currentDiscipline()) activate(false);
    else deactivate();
  }

  document.addEventListener('gara-discipline:change', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();

  /* Poll every 5 minutes - cheap, swaps only when the 2-hour bucket rolls over. */
  setInterval(function(){
    if (!currentDiscipline()) return;
    var bucket = Math.floor(Date.now() / BUCKET_MS);
    if (bucket !== lastBucket) activate(true);
  }, 5 * 60 * 1000);
})();
